import { useCallback } from 'react';
import type { StorageUnit } from 'store/storageunits/types';
import { isProject as isProjectUtil } from 'util/isProjectHelper';

/**
 * Hook to check if a storage unit is a project.
 *
 * A unit is considered a project if it has project metadata.
 * Both internal and external users can view projects.
 *
 * @returns A function that takes a StorageUnit and returns whether it's a project
 */
export const useIsProject = () => {
  const isProject = useCallback((unit: StorageUnit): boolean => {
    return isProjectUtil(unit);
  }, []);

  return isProject;
};
